var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton } from '@mui/material';
var LoginPageBackButton = function (_a) {
    var setValue = _a.setValue;
    return (_jsx(Box, __assign({ sx: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            marginTop: 1,
            marginLeft: 1
        } }, { children: _jsx(IconButton, __assign({ "aria-label": "expand row", size: "small", onClick: function (e) {
                setValue(0);
            } }, { children: _jsx(ArrowBackIcon, {}, void 0) }), void 0) }), void 0));
};
export default LoginPageBackButton;
